import {
  getAxiosAdminOrganizationRequest,
  getAxiosOrganizationUsersRequest,
  patchAxiosOrganizationUserRequest,
} from "@API";
import {
  createGetOrganizationUserInterceptors,
  createGetOrganizationUsersInterceptors,
  createPatchOrganizationUserInterceptors,
} from "@API/Users/middlewares";
import {
  IAxiosOrganizationUser,
  IGetAxiosOrganizationUser,
  IGetAxiosOrganizationUsers,
  IPatchAxiosOrganizationUsers,
} from "@API/Users/types";
import {
  IOrganizationUser,
  OrganizationId,
  OrganizationUserId,
  PatchOrganizationUserBody,
} from "@Store/Organizations/types";
import { AxiosInstance, AxiosResponse } from "axios";

export const getAxiosOrganizationUsers = async (
  orgId: OrganizationId,
  active: boolean | null = null
): Promise<IGetAxiosOrganizationUsers> => {
  const organizationUsersRequest: AxiosInstance =
    getAxiosAdminOrganizationRequest();

  createGetOrganizationUsersInterceptors(organizationUsersRequest);

  const activeQueryParam = active === null
    ? ''
    : `?active=${active}`;

  const response: AxiosResponse = await organizationUsersRequest.get(
    `${orgId}/users${activeQueryParam}`
  );

  const organizationUsersData: IOrganizationUser[] = response.data;

  return { data: organizationUsersData };
};

export const getAxiosOrganizationUser = async (
  orgId: OrganizationId,
  userId: OrganizationUserId
): Promise<IGetAxiosOrganizationUser> => {
  const organizationUserRequest: AxiosInstance =
    getAxiosOrganizationUsersRequest();

  createGetOrganizationUserInterceptors(organizationUserRequest);

  const response: AxiosResponse = await organizationUserRequest.get(
    `${orgId}/users/${userId}`
  );

  const organizationUserData: IOrganizationUser = response.data;

  return { data: organizationUserData };
};

export const patchAxiosOrganizationUser = async (
  organizationId: OrganizationId,
  userId: OrganizationUserId,
  body: PatchOrganizationUserBody
): Promise<IPatchAxiosOrganizationUsers> => {
  const changeOrganizationUsersRequest: AxiosInstance =
    patchAxiosOrganizationUserRequest();

  createPatchOrganizationUserInterceptors(changeOrganizationUsersRequest);

  const response: AxiosResponse = await changeOrganizationUsersRequest.patch(
    `${organizationId}/users/${userId}`,
    body
  );

  const changedOrganizationUserData: IOrganizationUser = response.data;

  return { data: changedOrganizationUserData };
};

export const putAxiosOrganizationUser = async (
  orgId: OrganizationId,
  body: IOrganizationUser
): Promise<IAxiosOrganizationUser> => {
  // const response = await getApiRequest().put(`/organizations/${orgId}/organization-users/${body.user.id}/`, formatBody(body));

  return { data: body };
};

export const postAxiosOrganizationUser = async (
  orgId: OrganizationId,
  body: IOrganizationUser
): Promise<IAxiosOrganizationUser> => {
  // const response = await getApiRequest().post(`/organizations/${orgId}/organization-users/${body.user.id}/`, formatBody(body));

  return {
    data: body,
  };
};

export const deleteAxiosOrganizationUser = async (
  orgId: OrganizationId,
  body: IOrganizationUser
): Promise<{}> => {
  // TODO: api call
  // const response = await getApiRequest().delete(`/organizations/${orgId}/organization-users/${body.user.id}/`);

  return {};
};
